import {
  feedLoader,
  profileChange,
  scrolling,
  showConfirm,
  showModal,
  signIn,
  spinObject,
  userData
} from 'main.js'
import $ from 'jquery'
import moment from 'moment'
// import PerfectScrollbar from 'perfect-scrollbar'


// // eslint-disable-next-line no-unused-vars
// const ps = new
// PerfectScrollbar('.sidebar', {
//   wheelSpeed: 2,
//   wheelPropagation: true,
//   minScrollbarLength: 20
// })

$(document).on('scroll', scrolling)

$('.menu-more').on('click', function () {
  $('.sidebar-wrap .collapse').collapse('show')
  $(this).hide()
})

// $('.dropdown-item').on('click', (e) => {
//   e.preventDefault()
// })

$(document).on('focusout', '.textarea', function () {
  const element = $(this)
  if (!element.text().replace(' ', '').length) {
    element.empty()
  }
})

$(document).on('click', '.add-comment', () => {
  $('.new-comment').find('.textarea').get(0).focus()
})


$(document).on('mousedown', '.add-smile', function () {
  const popover = $(this)
  const editor = $(popover).closest('.editor')
  const textarea = $(editor).find('.textarea')
  let sel = window.getSelection()
  let range = document.createRange()
  if (sel.type === 'None' || !$(':focus').is(textarea)) {
    range.selectNodeContents(textarea[0])
    range.collapse(false)
  } else {
    range = sel.getRangeAt(0)
  }
  $('.add-smile').popover({
    html: true,
    trigger: 'manual',
    placement: 'bottom',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body smiles"></div></div>',
    content() {
      const smiles = [
        {
          simbols: ['😬', '👏', '😮', '😍', '😂', '😡']
        },
        {
          title: '%%Смайлики и эмоции%%',
          simbols: ['😃', '😄', '😁', '😆', '😅', '😂', '😉', '😊', '😇', '😍', '😘', '😚', '😋', '😜', '😝', '😐', '😶', '😏', '😒', '😌', '😔', '😪', '😷', '😵', '😎', '😲', '😳', '😨', '😰', '😥', '😢', '😭', '😱', '😖', '😣', '😞', '😓', '😩', '😫', '😤', '😡', '😠', '😈', '👿', '💀', '☠️', '💩', '👹', '👺', '👻', '👽', '👾', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾', '🙈', '🙉', '🙊', '💋', '💌', '💘', '💝', '💖', '💗', '💓', '💞', '💕', '💟', '❣️', '💔', '❤️', '💛', '💚', '💙', '💜', '💯', '💢', '💥', '💫', '💦', '💨', '💣', '💬', '💭', '💤']
        }, {
          title: '%%Люди%%',
          simbols: ['👋', '✋', '👌', '✌️', '👈', '👉', '👆', '👇', '☝️', '👍', '👎', '✊', '👊', '👏', '🙌', '👐', '🙏', '✍️', '💅', '💪', '👂', '👃', '👀', '👅', '👄', '👶', '👦', '👧', '👨', '👩', '👱‍♀️', '👴', '👵', '🙍‍♂️', '🙍‍♀️', '🙎‍♂️', '🙎‍♀️', '🙅‍♂️', '🙅‍♀️', '🙆‍♂️', '🙆‍♀️', '💁‍♂️', '💁‍♀️', '🙋‍♂️', '🙋‍♀️', '🙇‍♂️', '🙇‍♀️', '👨‍⚕️', '👩‍⚕️', '👨‍🎓', '👩‍🎓', '👨‍🏫', '👩‍🏫', '👨‍⚖️', '👩‍⚖️', '👨‍🌾', '👩‍🌾', '👨‍🍳', '👩‍🍳', '👨‍🔧', '👩‍🔧', '👨‍🏭', '👩‍🏭', '👨‍💼', '👩‍💼', '👨‍🔬', '👩‍🔬', '👨‍💻', '👩‍💻', '👨‍🎤', '👩‍🎤', '👨‍🎨', '👩‍🎨', '👨‍✈️', '👩‍✈️', '👨‍🚀', '👩‍🚀', '👨‍🚒', '👩‍🚒', '👮‍♂️', '👮‍♀️', '💂‍♂️', '💂‍♀️', '👷‍♂️', '👷‍♀️', '👸', '👳‍♂️', '👳‍♀️', '👲', '👰', '👼', '🎅', '💆‍♂️', '💆‍♀️', '💇‍♂️', '💇‍♀️', '🚶‍♂️', '🚶‍♀️', '🏃‍♂️', '🏃‍♀️', '💃', '👯‍♂️', '👯‍♀️', '🏇', '⛷️', '🏂', '🏄‍♂️', '🏄‍♀️', '🚣‍♂️', '🚣‍♀️', '🏊‍♂️', '🏊‍♀️', '⛹️‍♂️', '⛹️‍♀️', '🚴‍♂️', '🚴‍♀️', '🚵‍♂️', '🚵‍♀️', '🛀', '👭', '👫', '👬', '👩‍❤️‍💋‍👨', '👨‍❤️‍💋‍👨', '👩‍❤️‍💋‍👩', '👩‍❤️‍👨', '👨‍❤️‍👨', '👩‍❤️‍👩', '👨‍👩‍👦', '👨‍👩‍👧', '👨‍👩‍👧‍👦', '👨‍👩‍👦‍👦', '👨‍👩‍👧‍👧', '👨‍👨‍👦', '👨‍👨‍👧', '👨‍👨‍👧‍👦', '👨‍👨‍👦‍👦', '👨‍👨‍👧‍👧', '👩‍👩‍👦', '👩‍👩‍👧', '👩‍👩‍👧‍👦', '👩‍👩‍👦‍👦', '👩‍👩‍👧‍👧', '👨‍👦', '👨‍👦‍👦', '👨‍👧', '👨‍👧‍👦', '👨‍👧‍👧', '👩‍👦', '👩‍👦‍👦', '👩‍👧', '👩‍👧‍👦', '👩‍👧‍👧', '👤', '👥', '👣']
        }, {
          title: '%%Животные и природа%%',
          simbols: ['🐵', '🐒', '🐶', '🐕', '🐩', '🐺', '🐱', '🐈', '🐯', '🐅', '🐆', '🐴', '🐎', '🐮', '🐂', '🐃', '🐄', '🐷', '🐖', '🐗', '🐽', '🐏', '🐑', '🐐', '🐪', '🐫', '🐘', '🐭', '🐁', '🐀', '🐹', '🐰', '🐇', '🐻', '🐨', '🐼', '🐾', '🐔', '🐓', '🐣', '🐤', '🐥', '🐦', '🐧', '🐸', '🐊', '🐢', '🐍', '🐲', '🐉', '🐳', '🐋', '🐬', '🐟', '🐠', '🐡', '🐙', '🐚', '🐌', '🐛', '🐜', '🐝', '🐞', '💐', '🌸', '💮', '🌹', '🌺', '🌻', '🌼', '🌷', '🌱', '🌲', '🌳', '🌴', '🌵', '🌾', '🌿', '☘️', '🍀', '🍁', '🍂', '🍃']
        }, {
          title: '%%Еда и напитки%%',
          simbols: ['🍇', '🍈', '🍉', '🍊', '🍋', '🍌', '🍍', '🍎', '🍏', '🍐', '🍑', '🍒', '🍓', '🍅', '🍆', '🌽', '🍄', '🌰', '🍞', '🍖', '🍗', '🍔', '🍟', '🍕', '🍳', '🍲', '🍱', '🍘', '🍙', '🍚', '🍛', '🍜', '🍝', '🍠', '🍢', '🍣', '🍤', '🍥', '🍡', '🍦', '🍧', '🍨', '🍩', '🍪', '🎂', '🍰', '🍫', '🍬', '🍭', '🍮', '🍯', '🍼', '☕', '🍵', '🍶', '🍷', '🍸', '🍹', '🍺', '🍻', '🍴', '🔪']
        }, {
          title: '%%Путешествия и места%%',
          simbols: ['🌍', '🌎', '🌏', '🌐', '🗾', '⛰️', '🌋', '🗻', '🏠', '🏡', '🏢', '🏣', '🏤', '🏥', '🏦', '🏨', '🏩', '🏪', '🏫', '🏬', '🏭', '🏯', '🏰', '💒', '🗼', '🗽', '⛪', '⛩️', '⛲', '⛺', '🌁', '🌃', '🌄', '🌅', '🌆', '🌇', '🌉', '♨️', '🎠', '🎡', '🎢', '💈', '🎪', '🚂', '🚃', '🚄', '🚅', '🚆', '🚇', '🚈', '🚉', '🚊', '🚝', '🚞', '🚋', '🚌', '🚍', '🚎', '🚐', '🚑', '🚒', '🚓', '🚔', '🚕', '🚖', '🚗', '🚘', '🚙', '🚚', '🚛', '🚜', '🚲', '🚏', '⛽', '🚨', '🚥', '🚦', '🚧', '⚓', '⛵', '🚤', '⛴️', '🚢', '✈️', '💺', '🚁', '🚟', '🚠', '🚡', '🚀', '⌛', '⏳', '⌚', '⏰', '⏱️', '⏲️', '🕛', '🕧', '🕐', '🕜', '🕑', '🕝', '🕒', '🕞', '🕓', '🕟', '🕔', '🕠', '🕕', '🕡', '🕖', '🕢', '🕗', '🕣', '🕘', '🕤', '🕙', '🕥', '🕚', '🕦', '🌑', '🌒', '🌓', '🌔', '🌕', '🌖', '🌗', '🌘', '🌙', '🌚', '🌛', '🌜', '☀️', '🌝', '🌞', '⭐', '🌟', '🌠', '🌌', '☁️', '⛅', '⛈️', '🌀', '🌈', '🌂', '☂️', '☔', '⛱️', '⚡', '❄️', '☃️', '⛄', '☄️', '🔥', '💧', '🌊']
        }, {
          title: '%%Занятия%%',
          simbols: ['🎃', '🎄', '🎆', '🎇', '✨', '🎈', '🎉', '🎊', '🎋', '🎍', '🎎', '🎏', '🎐', '🎑', '🎀', '🎁', '🎫', '🏆', '⚽', '⚾', '🏀', '🏈', '🏉', '🎾', '🎳', '⛳', '⛸️', '🎣', '🎽', '🎿', '🎯', '🎱', '🔮', '🎮', '🎰', '🎲', '♠️', '♥️', '♦️', '♣️', '♟️', '🃏', '🀄', '🎴', '🎭', '🎨']
        }, {
          title: '%%Предметы%%',
          simbols: ['👓', '👔', '👕', '👖', '👗', '👘', '👙', '👚', '👛', '👜', '👝', '🎒', '👞', '👟', '👠', '👡', '👢', '👑', '👒', '🎩', '🎓', '⛑️', '💄', '💍', '💎', '🔇', '🔈', '🔉', '🔊', '📢', '📣', '📯', '🔔', '🔕', '🎼', '🎵', '🎶', '🎤', '🎧', '📻', '🎷', '🎸', '🎹', '🎺', '🎻', '📱', '📲', '☎️', '📞', '📟', '📠', '🔋', '🔌', '💻', '⌨️', '💽', '💾', '💿', '📀', '🎥', '🎬', '📺', '📷', '📹', '📼', '🔍', '🔎', '💡', '🔦', '🏮', '📔', '📕', '📖', '📗', '📘', '📙', '📚', '📓', '📒', '📃', '📜', '📄', '📰', '📑', '🔖', '💰', '💴', '💵', '💶', '💷', '💸', '💳', '💹', '💱', '💲', '✉️', '📧', '📨', '📩', '📤', '📥', '📦', '📫', '📪', '📬', '📭', '📮', '✏️', '✒️', '📝', '💼', '📁', '📂', '📅', '📆', '📇', '📈', '📉', '📊', '📋', '📌', '📍', '📎', '📏', '📐', '✂️', '🔒', '🔓', '🔏', '🔐', '🔑', '🔨', '⛏️', '⚒️', '⚔️', '🔫', '🔧', '🔩', '⚙️', '⚖️', '🔗', '⛓️', '⚗️', '🔬', '🔭', '📡', '💉', '💊', '🚪', '🚽', '🚿', '🛁', '🚬', '⚰️', '⚱️', '🗿']
        }, {
          title: '%%Символы%%',
          simbols: ['🏧', '🚮', '🚰', '♿', '🚹', '🚺', '🚻', '🚼', '🚾', '🛂', '🛃', '🛄', '🛅', '⚠️', '🚸', '⛔', '🚫', '🚳', '🚭', '🚯', '🚱', '🚷', '📵', '🔞', '☢️', '☣️', '⬆️', '↗️', '➡️', '↘️', '⬇️', '↙️', '⬅️', '↖️', '↕️', '↔️', '↩️', '↪️', '⤴️', '⤵️', '🔃', '🔄', '🔙', '🔚', '🔛', '🔜', '🔝', '⚛️', '✡️', '☸️', '☯️', '✝️', '☦️', '☪️', '☮️', '🔯', '♈', '♉', '♊', '♋', '♌', '♍', '♎', '♏', '♐', '♑', '♒', '♓', '⛎', '🔀', '🔁', '🔂', '▶️', '⏩', '⏭️', '⏯️', '◀️', '⏪', '⏮️', '🔼', '⏫', '🔽', '⏬', '⏏️', '🎦', '🔅', '🔆', '📶', '📳', '📴', '♀️', '♂️', '⚕️', '♾️', '♻️', '⚜️', '🔱', '📛', '🔰', '⭕', '✅', '☑️', '✔️', '✖️', '❌', '❎', '➕', '➖', '➗', '➰', '➿', '〽️', '✳️', '✴️', '❇️', '‼️', '⁉️', '❓', '❔', '❕', '❗', '〰️', '©️', '®️', '™️', '#️⃣', '*️⃣', '0️⃣', '1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟', '🔠', '🔡', '🔢', '🔣', '🔤', '🅰️', '🆎', '🅱️', '🆑', '🆒', '🆓', 'ℹ️', '🆔', 'Ⓜ️', '🆕', '🆖', '🅾️', '🆗', '🅿️', '🆘', '🆙', '🆚', '🈁', '🈂️', '🈷️', '🈶', '🈯', '🉐', '🈹', '🈚', '🈲', '🉑', '🈸', '🈴', '🈳', '㊗️', '㊙️', '🈺', '🈵', '🔴', '🔵', '⚫', '⚪', '⬛', '⬜', '◼️', '◻️', '◾', '◽', '▪️', '▫️', '🔶', '🔷', '🔸', '🔹', '🔺', '🔻', '💠', '🔘', '🔳', '🔲']
        }
      ]
      let html = ''
      smiles.forEach((value) => {
        if (Object.prototype.hasOwnProperty.call(value, 'title')) {
          html += `<p>${value.title}</p>`
        }
        value.simbols.forEach((simbol) => {
          html += `<a role="button">${simbol}</a>`
        })
      })
      return html
    }
  })
  $(popover).popover('show')
  $(popover).on('shown.bs.popover', () => {
    sel.removeAllRanges()
    sel.addRange(range)
    $('.smiles a').off('click')
    $('.smiles a').on('click', function () {
      range.deleteContents()
      const textNode = document.createTextNode(this.text)
      range.insertNode(textNode)
      range.setStartAfter(textNode)
      sel.removeAllRanges()
      sel.addRange(range)
    })
    $(textarea).off('keyup')
    $(textarea).on('keyup', (e) => {
      const key = e.keyCode || e.which
      if (key === 16 || key === 17 || key === 91) {
        sel = window.getSelection()
        sel.getRangeAt(0)
        range = sel.getRangeAt(0)
      }
    })
  })
})

$(document).on('click', 'body', (e) => {
  if ($(e.target).closest('.add-smile').is('a') && $(e.target).closest('.popover').is('.show') || !$(e.target).closest('.popover').is('.show') && !$(e.target).closest('.add-smile').is('a')) {
    $('[data-original-title]').popover('hide')
  }
})

$(document).on('click', '.reply', function () {
  if (userData) {
    if (userData.confirmed) {
      const root = $(this).closest('.root')
      const editor = `
        <div class="new-comment">
          <a role="button" class="btn text-secondary profile" data-original-title="" style="background-image: url(/img/users/${userData.id}.jpg${profileChange ? `?${Math.random()}` : ''});"></a>
          <div class="editor">
            <div class="textarea" contentEditable="true" data-placeholder="%%Новый комментарий%%"></div>
            <div class="controls">
              <a role="button" class="text-secondary add-smile"><i class="icon-smile"></i></a>
              <!-- <a role="button" class="text-secondary add-photo"><i class="icon-camera"></i></a> -->
              <a role="button" class="text-primary send"><i class="icon-send"></i></a>
            </div>
            <div class="background"></div>
          </div>
        </div>
      `
      if ($(root).has('.load-answers').length > 0) {
        loadAnswers($(root).find('.load-answers'), editor)
      } else if ($(root).has('.answers').length > 0) {
        if ($(root).has('.editor').length === 0) {
          $(root).find('.answers').append(editor)
        }
      } else {
        $(this).closest('.root').append(`
            <div class="answers">
              <div class="loaded">
                <i class="icon-subdirectory"></i>
              </div>
              ${editor}
            </div>
          `)
      }
      $(root).find('.textarea').focus()
    } else {
      showConfirm()
    }
  } else {
    signIn()
  }
})

$(document).on('click', '.editor .send', function () {
  if (userData) {
    if (userData.confirmed) {
      const root = $(this).closest('.root').is('div') ? $(this).closest('.root') : false
      const obj = $(this)
      const textarea = $(this).closest('.editor').find('.textarea')
      const rootId = root ? $(root).children('.comment').attr('data-id') : ''
      $.ajax({
        dataType: 'json',
        type: 'post',
        url: '/api/comment.json',
        data: `post=${$('.sidebar-wrap .likes').attr('data-id')}&comment=${$(textarea).html().replaceAll('<br>', '').replaceAll('<div>', '<br>').replaceAll('</div>', '')}&root=${rootId}`,
        beforeSend: () => {
          $('.glass').show()
          obj.html('<i class="icon-spinner icon-spin"></i>')
        },
        success: (data) => {
          data.status = 1
          obj.html('<i class="icon-send"></i>')
          $('.glass').hide()
          if (data.error) {
            window.console.log(data.error)
          } else {
            if (root) {
              $(obj).closest('.new-comment').replaceWith(createComment(data))
            } else {
              $('.comment-line').prepend(`
                <div class="root">
                  ${createComment(data)}
                </div>
              `)
              $(textarea).empty()
            }
            const comments = Number($('.comments .counter').text())
            $('.comments .counter').text(comments + 1)
            $('.comment-icon').text(comments + 1)
          }
        },
        error: (jqXHR, textStatus, errorThrown) => {
          window.console.log(jqXHR, textStatus, errorThrown)
        }
      })
    } else {
      showConfirm()
    }
  } else {
    signIn()
  }
})

$(document).on('click', '.load-answers', function () {
  const obj = $(this)
  loadAnswers(obj)
})

function createComment(data) {
  return `
    <div class="comment" data-id="${data.id}">
      <div class="header">
        <div class="avatar" style="background-image: url(/img/users/${data.avatar}.jpg${profileChange ? `?${Math.random()}` : ''});"></div>
        <div class="name">${data.autor}</div>
        <div class="date" data-toggle="tooltip">${moment.unix(data.date).format('YYYY.MM.DD HH:mm')}</div>
      </div>
      ${data.status === 1 ? `
        <div class="body">
          ${data.body}
        </div>
        <div class="footer">
          <a role="button" class="reply">Ответить</a>
          <button class="menu btn btn-sm btn-white"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="icon-more"></i></button>
          <div class="dropdown-menu">
            <a role="button" class="dropdown-item complaint"><i class="icon-report"></i>%%Пожаловаться%%</a>
          </div>
        </div>
      ` : `
        <div class="body text-muted font-italic">
          %%Комментарий был удален администрацией%%
        </div>
      `}
    </div>
  `
}

function loadAnswers(obj, editor) {
  const root = $(obj).closest('.root')
  const rootId = root ? $(root).children('.comment').attr('data-id') : ''
  $.ajax({
    dataType: 'json',
    type: 'post',
    url: '/api/answers.json',
    data: `post=${$('.sidebar-wrap .likes').attr('data-id')}&root=${rootId}`,
    beforeSend: () => {
      $('.glass').show()
      obj.append('<i class="icon-spinner icon-spin"></i>')
    },
    success: (data) => {
      if (data.error) {
        obj.find('.icon-spinner').remove()
        window.console.log(data.error)
      } else {
        let items = ''
        data.forEach((item) => {
          items += createComment(item)
        })
        obj.replaceWith(`
          <div class="answers">
            <div class="loaded">
              <i class="icon-subdirectory"></i>
            </div>
            ${items}
            ${editor ? editor : ''}
          </div>
        `)
        $('.glass').hide()
      }
      if (editor) {
        $(root).find('.textarea').focus()
      }
    },
    error: (jqXHR, textStatus, errorThrown) => {
      window.console.log(jqXHR, textStatus, errorThrown)
    }
  })
}


$(document).on('click', '.complaint', function () {
  if (userData) {
    if (userData.confirmed) {
      const id = $(this).closest('.comment').attr('data-id')
      if ($('.modal').is('.show')) {
        $('.modal').modal('hide')
      }
      showModal('', `
        <h5 class="mb-4">%%Укажите причину жалобы%%</h5>
        <input type="hidden" name="comment" value="${id}">
        <div class="form-group">
          <div class="custom-control custom-radio">
            <input type="radio" id="radio1" name="type" class="custom-control-input radio" value="1">
            <label class="custom-control-label" for="radio1">%%Он оскорбителен%%</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="radio2" name="type" class="custom-control-input radio" value="2">
            <label class="custom-control-label" for="radio2">%%Это спам или мошенничество%%</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="radio3" name="type" class="custom-control-input radio" value="3">
            <label class="custom-control-label" for="radio3">%%Он неуместен%%</label>
          </div>
        </div>
        <button class="btn btn-lg btn-warning mt-4" type="submit">Отправить</button>
      `, 'auth', () => {
        const validator = $('.validate').validate({
          rules: {
            type: {
              required: true
            }
          },
          messages: {
            type: {
              required: '%%Необходимо выбрать причину жалобы%%'
            }
          },
          submitHandler: () => {
            const spinner  = spinObject($('.modal [type="submit"]'))
            $.ajax({
              dataType: 'json',
              type: 'post',
              url: '/api/comment-complaint.json',
              data: $('form[name=confirm-form]').serialize(),
              beforeSend: () => {
                $('.summary-error').remove()
                // $('.glass').show()
                spinner.animate({
                  width: 24,
                  'margin-right': 4
                })
              },
              success: (data) => {
                spinner.animate({
                  width: 0,
                  'margin-right': 0
                })
                $('.glass').hide()
                if (data.error) {
                  if (typeof data.error === 'string') {
                    $('form .form-group').last().append(`<div class="summary-error" style="">${data.error}</div>`)
                  } else {
                    validator.showErrors(data.error)
                  }
                } else {
                  $('.modal').modal('hide')
                  showModal('', `
                  <div class="header mb-4 px-2">%%Ваша жалоба зарегистрирована. В ближайшее время она будет рассмотрена. Если комментарий действительно не соответствует правилам он будет удален.%%</div>
                    <button class="btn btn-lg btn-warning mt-3" type="button" data-dismiss="modal">%%Закрыть%%</button>
                `, 'auth')
                }
              },
              error: (jqXHR, textStatus, errorThrown) => {
                window.console.log(jqXHR, textStatus, errorThrown)
              }
            })
          }
        })
      })
    } else {
      showConfirm()
    }
  } else {
    signIn()
  }
})

$(document).on('click', '.article_complaint', () => {
  if (userData) {
    if (userData.confirmed) {
      const id = $('.btn-group-vertical.likes').attr('data-id')
      if ($('.modal').is('.show')) {
        $('.modal').modal('hide')
      }
      showModal('', `
        <h5 class="mb-4">%%Что не так с публикацией?%%</h5>
        <input type="hidden" name="comment" value="${id}">
        <div class="form-group">
          <div class="custom-control custom-radio">
            <input type="radio" id="radio1" name="type" class="custom-control-input radio" value="1">
            <label class="custom-control-label" for="radio1">%%Она оскорбителена%%</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="radio2" name="type" class="custom-control-input radio" value="2">
            <label class="custom-control-label" for="radio2">%%Содержит ложную информацию%%</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="radio3" name="type" class="custom-control-input radio" value="3">
            <label class="custom-control-label" for="radio3">%%Непристойное содержание%%</label>
          </div>
          <div class="custom-control custom-radio">
            <input type="radio" id="radio4" name="type" class="custom-control-input radio" value="4">
            <label class="custom-control-label" for="radio4">%%Отсутствует на источнике%%</label>
          </div>
        </div>
        <button class="btn btn-lg btn-warning mt-4" type="submit">%%Отправить%%</button>
      `, 'auth', () => {
        const validator = $('.validate').validate({
          rules: {
            type: {
              required: true
            }
          },
          messages: {
            type: {
              required: '%%Необходимо выбрать причину жалобы%%'
            }
          },
          submitHandler: () => {
            const spinner  = spinObject($('.modal [type="submit"]'))
            $.ajax({
              dataType: 'json',
              type: 'post',
              url: '/api/article_complaint.json',
              data: $('form[name=confirm-form]').serialize(),
              beforeSend: () => {
                $('.summary-error').remove()
                $('.glass').show()
                spinner.animate({
                  width: 24,
                  'margin-right': 4
                })
              },
              success: (data) => {
                spinner.animate({
                  width: 0,
                  'margin-right': 0
                })
                $('.glass').hide()
                if (data.error) {
                  if (typeof data.error === 'string') {
                    $('form .form-group').last().append(`<div class="summary-error" style="">${data.error}</div>`)
                  } else {
                    validator.showErrors(data.error)
                  }
                } else {
                  $('.modal').modal('hide')
                  showModal('', `
                  <div class="header mb-4 px-2">%%Ваша жалоба зарегистрирована. В ближайшее время она будет рассмотрена. Если публикация действительно не соответствует правилам она будет удалена.%%</div>
                    <button class="btn btn-lg btn-warning mt-3" type="button" data-dismiss="modal">%%Закрыть%%</button>
                `, 'auth')
                }
              },
              error: (jqXHR, textStatus, errorThrown) => {
                window.console.log(jqXHR, textStatus, errorThrown)
              }
            })
          }
        })
      })
    } else {
      showConfirm()
    }
  } else {
    signIn()
  }
})

$(document).on('click', '.delete-forever', () => {
  if (userData) {
    if (userData.confirmed) {
      const id = $('.btn-group-vertical.likes').attr('data-id')
      if ($('.modal').is('.show')) {
        $('.modal').modal('hide')
      }
      showModal('', `
        <h5 class="mb-4 text-danger text-center">%%Безвозвратное удаление публикации!%%</h5>
        <input type="hidden" name="id" value="${id}">
        <p class="text-center">%%Вы действительно хотите удалить публикацию? Это действие необратимо и восстановить публикацию уже не удастся!%%</p>
        <button class="btn btn-lg btn-light mt-4" data-dismiss="modal">%%Закрыть%%</button>
        <button class="btn btn-lg btn-danger mt-3" type="submit">%%Удалить навсегда%%</button>
      `, 'auth', () => {
        const validator = $('.validate').validate({
          rules: {
            type: {
              required: true
            }
          },
          messages: {
            type: {
              required: '%%Необходимо выбрать причину жалобы%%'
            }
          },
          submitHandler: () => {
            const spinner  = spinObject($('.modal [type="submit"]'))
            $.ajax({
              dataType: 'json',
              type: 'post',
              url: '/api/delete_forever.json',
              data: $('form[name=confirm-form]').serialize(),
              beforeSend: () => {
                $('.summary-error').remove()
                $('.glass').show()
                spinner.animate({
                  width: 24,
                  'margin-right': 4
                })
              },
              success: (data) => {
                spinner.animate({
                  width: 0,
                  'margin-right': 0
                })
                $('.glass').hide()
                if (data.error) {
                  if (typeof data.error === 'string') {
                    $('form .form-group').last().append(`<div class="summary-error" style="">${data.error}</div>`)
                  } else {
                    validator.showErrors(data.error)
                  }
                } else {
                  $('.modal').modal('hide')
                  location.href = '/'
                }
              },
              error: (jqXHR, textStatus, errorThrown) => {
                window.console.log(jqXHR, textStatus, errorThrown)
              }
            })
          }
        })
      })
    } else {
      showConfirm()
    }
  } else {
    signIn()
  }
})

$(document).on('click', '.pin-article', function () {
  if (userData) {
    if (userData.confirmed) {
      const id = $('.btn-group-vertical.likes').attr('data-id')
      if ($('.modal').is('.show')) {
        $('.modal').modal('hide')
      }
      const obj = $(this)
      const pin = $(this).is('.pin-active')
      showModal('', `
        <h5 class="mb-4 text-warning text-center">${pin ? '%%Снять прикрепление%%' : '%%Прикрепить публикацию%%'}</h5>
        <input type="hidden" name="pin" value="${pin ? 0 : 1}">
        <input type="hidden" name="id" value="${id}">
        <p class="text-center">${pin ? '%%Вы действительно хотите убрать публикацию из прикрепленных?%%' : '%%Вы действительно хотите прикрепить публикацию?%%'}</p>
        <button class="btn btn-lg btn-light mt-4" data-dismiss="modal">%%Закрыть%%</button>
        <button class="btn btn-lg btn-warning mt-3" type="submit">${pin ? '%%Снять прикрепление%%' : '%%Прикрепить публикацию%%'}</button>
      `, 'auth', () => {
        const validator = $('.validate').validate({
          submitHandler: () => {
            const spinner  = spinObject($('.modal [type="submit"]'))
            $.ajax({
              dataType: 'json',
              type: 'post',
              url: '/api/pin_article.json',
              data: $('form[name=confirm-form]').serialize(),
              beforeSend: () => {
                $('.summary-error').remove()
                $('.glass').show()
                spinner.animate({
                  width: 24,
                  'margin-right': 4
                })
              },
              success: (data) => {
                spinner.animate({
                  width: 0,
                  'margin-right': 0
                })
                $('.glass').hide()
                if (data.error) {
                  if (typeof data.error === 'string') {
                    $('form .form-group').last().append(`<div class="summary-error" style="">${data.error}</div>`)
                  } else {
                    validator.showErrors(data.error)
                  }
                } else {
                  $('.modal').modal('hide')
                  $(obj).toggleClass('pin-active').find('span').text(pin ? '%%Прикрепить публикацию%%' : '%%Снять прикрепление%%')
                }
              },
              error: (jqXHR, textStatus, errorThrown) => {
                window.console.log(jqXHR, textStatus, errorThrown)
              }
            })
          }
        })
      })
    } else {
      showConfirm()
    }
  } else {
    signIn()
  }
})

feedLoader(1)
